import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.split";
export function parseFormat(text) {
  return text.match(/Format\s*:\s*(.*)/i)[1].split(/\s*,\s*/);
}